<template>
  <custom-dialog
    width="1400px"
    class="bank-account-manage-dialog"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    :title="model.title"
  >
    <div class="dialog-body">
      <div class="search-hd">
        <el-form
          v-if="editEnable && accountManage &&!!model.isPaymentConditionMet"
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item >
            <el-button
              type="primary"
              icon="el-icon-plus"

              @click="onAddBtn"
            >{{ $t('Common.com_add') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          index
          :data="tableList"
          type="radio"
          :clickSelection="true"
          tableCode="bank_card_list"
          height="500"
          :slots="['action']"
          @filter="filterChange"
          @sort="sortChange"
          @on-row-click="onRowClick"
        >
          <template v-slot:action="scope">
            <span></span>
            <el-button
              type="text"
              size="mini"
              @click.stop="onEditBtn(scope.row)"
              v-if="editEnable && accountManage&&!!model.isPaymentConditionMet"
            >{{ $t('Common.com_edit') }}</el-button>
            <el-button
              type="text"
              size="mini"
              @click.stop="onDefault(scope.row)"
              v-if="!scope.row.isDefault && editEnable && accountManage&&!!model.isPaymentConditionMet"
            >{{ $t('fms_bank_account_manage_dialog.mo_ren') }}</el-button>
            <template v-if="editEnable && accountManage&&!!model.isPaymentConditionMet">
              <el-dropdown @click.native.stop>
                <span class="el-dropdown-more">
                  {{ $t('fms_bank_account_manage_dialog.geng_duo') }}
                  <i class="icon icon-xiala"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onDel(scope.row)">
                    {{ $t('Common.com_delete') }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="!scope.row.state"
                    @click.native="onEnable(scope.row)"
                  >
                    {{ $t('Common.com_enable') }}
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state"
                    @click.native="onDisable(scope.row)"
                  >
                    {{ $t('Common.com_disable') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </custom-table>
      </div>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="onCancel">{{ $t('Common.com_close') }}</el-button>
      <el-button
        :disabled="!curRow"
        type="primary"
        @click="onConfirm"
      >{{ $t('fms_bank_account_manage_dialog.que_ren') }}</el-button>
    </div>
    <!--添加/编辑银行卡-->
    <bankcard-address-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="onSuccess"
    >
    </bankcard-address-dialog>
  </custom-dialog>
</template>

<script>
/** 银行账户管理（账户选择） */

import dialogMixins from '@/mixins/dialog_mixins';
import apis from '@/utils/apis';
import bankcardAddressDialog from '@/pages/crm/components/bankCardDialog.vue';

export default {
  name: '',
  mixins: [dialogMixins],
  components: {
    bankcardAddressDialog
  },
  props: {
    orgId: {
      type: String,
      required: true
    },
    // 操作是是收款方账户还是付款方账户
    // 如果是true，则为付款方账号，如果是false，为收款方账户
    isPayableAccountType: {
      type: Boolean,
      default: false
    },
    // 登录账户是否为付款方
    isPayableOrgan: {
      type: Boolean,
      default: false
    },
    // 权限-账户管理, 默认有
    accountManage: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      tableList: [],
      tableSelect: [],
      formSearch: {
        pageSize: 50,
        pageNum: 1
      },
      totalRows: null,
      curRow: null,
      dialogVisible: false,
      dialogModel: {},
    };
  },
  computed: {
    editEnable() {
      if (!this.isPayableAccountType) {
        return !this.isPayableOrgan;
      }
      return true;
    }
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 判断是否只有一个选项是true
    hasOneTrue(...args) {
      const arr = [...args];
      const ret = arr.filter(item => !!item);
      return ret.length === 1;
    },
    onSuccess(form) {
      this.$emit(this.dialogModel.type, form);
      this.getTableList();
    },
    // 编辑银行卡
    onEditBtn: function (item) {
      this.dialogModel.title = this.$t('Common.com_edit');
      this.dialogModel.type = 'edit';
      this.dialogModel.data = { item };
      this.dialogVisible = true;
    },
    // 新增银行卡
    onAddBtn: function () {
      this.dialogModel.title = this.$t('Common.com_add');
      this.dialogModel.type = 'add';
      this.dialogModel.partnerOrgId = this.orgId;
      this.dialogVisible = true;
    },
    onRowClick(row) {
      this.curRow = row;
    },
    onPreview(row) {
      this.imgPreData = row.attachs;
      this.showPreDialog = true;
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      this.$emit('confirm', this.curRow);
      this.closeDialog();
    },
    onCancel() {
      this.closeDialog();
    },
    getTableList() {
      const reqData = {
        orgId: this.orgId
      };
      this.$getJSON(apis.PartnerBankcardListByOrgId, reqData).then((res) => {
        this.tableList = res.data;
      });
    },
    // 您确定要将选中的银行卡设为默认银行卡吗? bankcardId
    onDefault(row) {
      const { bankcardId } = row;
      const tips = this.$t('fms_bank_account_manage_dialog.nqdyjxzdyhkswmryhkm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.partnerBankcardDefualt}/${bankcardId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.getTableList();
        });
      });
    },
    onDisable(row) {
      const { bankcardId } = row;
      const tips = this.$t('fms_bank_account_manage_dialog.nqdyjyxzdyhkm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.PartnerBankcardDisableOrEnable}/${bankcardId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.getTableList();
        });
      });
    },
    onEnable(row) {
      const { bankcardId } = row;
      const tips = this.$t('fms_bank_account_manage_dialog.nqdyqyxzdyhkm');
      this.$showConfirm(tips).then(() => {
        this.$postJSON(`${apis.PartnerBankcardDisableOrEnable}/${bankcardId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.getTableList();
        });
      });
    },
    onDel(row) {
      const { bankcardId } = row;
      const tips = this.$t('fms_bank_account_manage_dialog.nqdyscxzdyhkm');
      this.$showConfirm(tips).then(() => {
        this.$deleteJSON(`${apis.partnerBankcardDelete}/${bankcardId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.getTableList();
        });
      });
    }
  },
  created() { },
  mounted() {
    this.getTableList();
  }
};
</script>

<style lang="scss">
.bank-account-manage-dialog {
  .dialog-body {
    padding-top: 0 !important;
  }
}
</style>
